import { render, staticRenderFns } from "./GenericDocumentViewer.vue?vue&type=template&id=342e38e6&scoped=true&"
import script from "./GenericDocumentViewer.vue?vue&type=script&lang=js&"
export * from "./GenericDocumentViewer.vue?vue&type=script&lang=js&"
import style0 from "./GenericDocumentViewer.vue?vue&type=style&index=0&id=342e38e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342e38e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VRow})
